module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-main"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_vm._m(0), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Add-ons Cost")]), _vm._v(" "), _c('div', {
    staticClass: "page-header-actions"
  }, [_c('div', {
    staticClass: "row no-space w-120"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "counter"
  }, [_c('div', {
    staticClass: "counter-label p-t-5"
  }, [_vm._v("Total Add-ons")]), _vm._v(" "), _c('span', {
    staticClass: "counter-number font-weight-medium"
  }, [_vm._v(_vm._s(_vm.total_addon))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body panel-form"
  }, [(_vm.isLoading) ? _c('loading-indicator') : (_vm.isError) ? _c('div') : _c('div', [_c('div', {
    staticClass: "p-b-15"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 col-md-6"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/admin/addon-cost/create")
    }
  }, [_c('i', {
    staticClass: "icon md-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "text hidden-sm-down"
  }, [_vm._v(" Create ")])])], 1)])]), _vm._v(" "), (_vm.addons.length > 0) ? _c('div', {
    staticClass: "table-striped table-hover table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "cell-30"
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticClass: "cell-300"
  }, [_vm._v("Description")]), _vm._v(" "), _c('th', {
    staticClass: "cell-300"
  }, [_vm._v("Team")]), _vm._v(" "), _c('th', {
    staticClass: "cell-100"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "cell-100"
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticClass: "cell-200"
  }, [_vm._v("Use on Billing Monthly")]), _vm._v(" "), _c('th', {
    staticClass: "cell-50"
  })])]), _vm._v(" "), _c('tbody', _vm._l((_vm.addons), function(item, index) {
    return _c('tr', [_c('td', {
      staticClass: "cell-30"
    }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', {
      staticClass: "cell-300"
    }, [_vm._v(_vm._s(item.description))]), _vm._v(" "), _c('td', {
      staticClass: "cell-300"
    }, [_c('router-link', {
      attrs: {
        "to": ("/" + (_vm.$route.params.namespace) + "/admin/teams/" + (item.team.namespace) + "/billings")
      }
    }, [_vm._v("\n                      " + _vm._s(item.team.namespace) + "\n                    ")])], 1), _vm._v(" "), _c('td', {
      staticClass: "cell-100 text-nowrap"
    }, [(!item.is_deactivate) ? _c('span', {
      staticClass: "tag tag-success"
    }, [_vm._v("Available")]) : _c('span', {
      staticClass: "tag tag-danger"
    }, [_vm._v("Deactivate")])]), _vm._v(" "), _c('td', {
      staticClass: "cell-100"
    }, [(item.type == 'recurring') ? _c('span', [_vm._v("Recurring")]) : _c('span', [_vm._v("One Time")])]), _vm._v(" "), _c('td', {
      staticClass: "cell-200"
    }, [_c('span', [_vm._v(_vm._s(_vm.getDate(item.started_at)))]), _vm._v(" "), (item.terminated_at) ? _c('span', [_vm._v("- " + _vm._s(_vm.getDate(item.terminated_at)))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "cell-50 text-nowrap"
    }, [(!item.is_deactivate) ? _c('button', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "alt": "Deactivate"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.changeItem(item, index)
        }
      }
    }, [_vm._v("Deactive\n                    ")]) : _vm._e()])])
  }))])]) : _c('div', {
    staticClass: "alert alert-primary alert-dismissible"
  }, [_vm._v("\n            There is no Add-ons.\n          ")])]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.pagination.total_page > 1)),
      expression: "(pagination.total_page > 1)"
    }],
    attrs: {
      "pageCount": _vm.pagination.total_page,
      "prevText": '«',
      "nextText": '»',
      "clickHandler": _vm.changePage,
      "containerClass": 'pagination pull-right',
      "pageClass": 'page-item',
      "pageLinkClass": 'page-link',
      "prevClass": 'page-item',
      "prevLinkClass": 'page-link',
      "nextClass": 'page-item',
      "nextLinkClass": 'page-link'
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item active"
  }, [_vm._v("Admin")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-602e0294!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/addons/AddonCostBrowser.vue
// module id = 540
// module chunks = 1